import { useLDClient } from 'launchdarkly-react-client-sdk';

import { FEATURE_FLAG_DEFAULTS } from '@/constants';
import { FeatureFlagSet } from '@/types';
/**
 * Query a feature flag, using the fallback defined in FLAG_DEFAULTS if the feature-flag SDK is uninitialized or unavailable.
 */
export const useFeatureFlag = <T extends keyof FeatureFlagSet>(name: T): FeatureFlagSet[T] => {
  return useLDClient()?.variation(name, FEATURE_FLAG_DEFAULTS[name]) ?? FEATURE_FLAG_DEFAULTS[name];
};
